<template>
  <div class="fts-import-designer">
    <!-- <fts-form
      :form="form"
      :formData="formData"
      v-if="!userImport" 
    />-->
    <div class="fts-row gutters" v-if="!userImport">
      <!-- test -->
      <div class="fts-col fts-col-md-4">
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'test',
            input: 'toggleSwitch',
          }"
          comfort-design
        />
      </div>
      <!-- preprocess -->
      <div class="fts-col fts-col-md-4">
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'preprocess',
            input: 'toggleSwitch',
          }"
          comfort-design
        />
      </div>
      <!-- initial state -->
      <div class="fts-col fts-col-md-4">
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'initialStateId',
            displayName: 'Initial State',
            icon: 'fts-icon-menu-caret-down',
          }"
          comfort-design
        >
          <fts-select
            slot="formElement"
            slot-scope="{ formData, item }"
            :form-data="formData"
            :item="item"
            :options="states"
            comfort-design
          >
            <fts-state slot="selected-option-container" slot-scope="{option}" :state="option" />
            <fts-state slot="option" slot-scope="{option}" :state="option" />
          </fts-select>
        </fts-form-element>
      </div>

      <!-- to merge -->
      <!-- <div class="fts-col fts-col-md-4">
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'preprocess',
            input: 'toggleSwitch',
          }"
          comfort-design
        />
      </div>-->

      <div class="fts-col fts-col-md-4">
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'merge',
            displayName: 'Merge entry with the same information',
            icon: 'fts-icon-menu-caret-down',
          }"
          comfort-design
        >
          <fts-select
            slot="formElement"
            slot-scope="{ formData, item }"
            :form-data="formData"
            :item="item"
            :reduce="(x) => x"
            :options="informationSelection"
            comfort-design
          >
            <div slot="selected-option-container" slot-scope="{option}">{{option.displayName}}</div>
            <div slot="option" slot-scope="{option}">{{option.displayName}}</div>
          </fts-select>
        </fts-form-element>
      </div>
    </div>
    <!-- upload -->
    <div class="fts-form-group">
      <div class="fts-form-label">Import File</div>
      <fts-file-upload
        :item="{
          displayName: 'Import Excel (.xlsx)',
          fieldName: 'importExcel',
        }"
        :form-data="formData"
        :additional-form-data="{ 'import': 'import' }"
        @fileUploaded="fileUploaded"
      />
      <fts-btn
        sm
        outline
        color="primary"
        text-transform-init
        class="import-refresh-btn"
        @click="refreshData()"
        v-if="formData.importExcel && formData.importExcel.path"
      >Refresh Data</fts-btn>
    </div>
    <!-- column setup -->
    <div class="fts-form-group" v-if="!userImport">
      <div class="fts-form-label">Spreadsheet Information Mapping</div>
      <fts-table-edit
        :item="headerColumns"
        :form-data="formData"
        :vector-id="vectorId"
        class="compact-form-design"
      />
    </div>
    <!-- excel data -->
    <div class="fts-form-group">
      <div class="fts-form-label">Spreadsheet Data</div>
      <table class="fts-table-edit">
        <thead>
          <tr>
            <th v-for="column in spreadsheetDataColumns" :key="column.fieldName">
              <div>
                <div>
                  {{column.displayName}}
                  <span v-if="column.fieldName != 'error'">(Spreadsheet)</span>
                </div>
                <div style="color: orange;">
                  {{column.information}}
                  <span v-if="column.fieldName != 'error'">(Information)</span>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in importData.rows" :key="index">
            <td v-for="column in spreadsheetDataColumns" :key="column.id">
              <fts-display class="form-display-borderless" :item="column" :formData="row"></fts-display>
              <span v-if="formData.merge && column.update && row.isUpdate">(To be updated)</span>
              <span v-if="column.merge && row.isUpdate">(Found)</span>
              <span v-if="row[column.fieldName + 'Id']">
                <font-awesome-icon class="success-theme" :icon="['fas', 'check']" fixed-width />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- import script -->
    <div class="fts-form-group" v-if="!userImport">
      <fts-script-editor
        editor-id="scriptEditor"
        :lang="'python'"
        label="Import Script"
        v-model="formData.script"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import VueJsonPretty from "vue-json-pretty";

import { classificationStore } from "../store/classificationStore";
import { store as canvasDesignStore } from "../store/canvasDesignStore";

import FTSForm from "../elements/FTSForm";
import FTSFormElement from "../elements/FTSFormElement";
import FTSBtn from "../elements/FTSBtn";
import FTSDisplay from "../elements/FTSDisplay";
import FTSFileUpload from "../elements/FTSFileUpload";
import FTSScriptEditor from "./FTSScriptEditor";
import FTSSelect from "../elements/FTSSelect";
import FTSState from "../elements/FTSState";
import FTSTableEdit from "../elements/FTSTableEdit";

export default {
  props: ["baseServer", "vectorId", "formData", "states", "userImport"],
  components: {
    VueJsonPretty,
    "fts-form": FTSForm,
    "fts-form-element": FTSFormElement,
    "fts-btn": FTSBtn,
    "fts-display": FTSDisplay,
    "fts-file-upload": FTSFileUpload,
    "fts-script-editor": FTSScriptEditor,
    "fts-select": FTSSelect,
    "fts-state": FTSState,
    "fts-table-edit": FTSTableEdit
  },
  data() {
    return {
      informationSelection: [],
      spreadsheetDataColumns: [],
      headerColumns: {
        fieldName: "columns",
        fields: [
          {
            id: "header",
            fieldName: "header",
            displayName: "Spreadsheet Header",
            input: "text",
            isReadyOnly: true
          },
          {
            id: "information",
            fieldName: "information",
            displayName: "Module Information",
            input: "select",
            displayProperty: "displayName",
            key: "informationId",
            optionList: []
          },
          {
            id: "update",
            fieldName: "update",
            displayName: "Merge Information",
            input: "boolean"
          },
          {
            id: "format",
            fieldName: "format",
            displayName: "Spreadsheet Format (if any special)",
            input: "text"
          }
        ]
      },
      columns: {
        fieldName: "rows",
        fields: []
      },
      importData: {
        rows: []
      }
    };
  },
  store: classificationStore,
  methods: {
    async import() {
      try {
        await this.$store.dispatch("importData", {
          vectorId: this.vectorId,
          formData: this.formData,
          rows: this.importData.rows,
          submit: true
        });
        this.$emit("import:success");
        this.$toasted.success("Import done");
      } catch (err) {
        console.error(err);
        this.$emit("import:error", err);

        if (err.response && err.response.data && err.response.data.message) {
          let errorMessage = err.response.data.message;
          this.$toasted.error(`Import failed: ${errorMessage}`);
        } else {
          this.$toasted.error("Import failed");
        }
      }
    },
    refreshData() {
      this.fileUploaded({
        url: this.formData.importExcel.path
      });
    },
    async fileUploaded(response) {
      try {
        const res = await this.$store.dispatch("importData", {
          url: response.url,
          vectorId: this.vectorId,
          formData: this.formData
        });
        this.importData.rows = res.data.rows;
        let canvasStore = canvasDesignStore;
        this.headerColumns.fields[1].optionList = res.data.information;
        this.informationSelection = res.data.information;
        if (
          !this.userImport ||
          (this.formData &&
            (!this.formData.columns ||
              (Array.isArray(this.formData.columns) &&
                this.formData.columns.length === 0)))
        ) {
          this.formData.columns = res.data.formData.columns;
        }

        this.spreadsheetDataColumns = res.data.formData.columns.slice();
        this.spreadsheetDataColumns.push({
          fieldName: "error",
          displayName: "Error"
        });
        this.columns = {
          fieldName: "rows",
          fields: this.spreadsheetDataColumns
        };
      } catch (err) {
        console.error("ImportDesigner:fileUploaded", err);
      }
    }
  },
  mounted() {
    let vm = this;
    vm.$store.dispatch("basicSetup", {
      baseServer: this.baseServer,
      token: JSON.parse(localStorage["ls.authorizationData"])["access_token"]
    });

    vm.$store.dispatch("setVector", {
      vectorId: this.vectorId
    });
  }
};
</script>

<style lang="scss" scoped>
.fts-import-designer {
  .import-refresh-btn {
    margin-top: 0.75rem;
  }
}
</style>